import { createSlice } from '@reduxjs/toolkit';
import dotPropImmutable from 'dot-prop-immutable';
import { uniqBy } from 'lodash';
const INITIAL_STATE = {
    users: [],
    teams: [],
    members: [],
    loadedAllMembers: false,
    loading: false,
    error: false
};
const MembersSlice = createSlice({
    name: 'members',
    initialState: INITIAL_STATE,
    reducers: (create)=>({
            resetStatus: create.reducer((state)=>{
                state.loadedAllMembers = false;
                state.error = false;
                state.loading = false;
            }),
            setMembers: create.reducer((state, { payload })=>{
                const { users = [], teams = [], members } = payload;
                // get the existing store data
                const userListFromState = dotPropImmutable.get(state, 'users', []);
                const teamsListFromStore = dotPropImmutable.get(state, 'teams', []);
                const membersFromStore = dotPropImmutable.get(state, 'members', []);
                // set the unique values
                let result = dotPropImmutable.set(state, 'users', uniqBy([
                    ...userListFromState,
                    ...users
                ], 'userId'));
                result = dotPropImmutable.set(result, 'teams', uniqBy([
                    ...teamsListFromStore,
                    ...teams
                ], 'teamId'));
                result = dotPropImmutable.set(result, 'members', [
                    ...membersFromStore,
                    ...members
                ]);
                return dotPropImmutable.set(result, 'loadedAllMembers', true);
            }),
            addUser: create.reducer((state, { payload })=>{
                const userListFromState = dotPropImmutable.get(state, 'users', []);
                return dotPropImmutable.set(state, 'users', uniqBy([
                    ...userListFromState,
                    payload
                ], 'userId'));
            }),
            addUsers: create.reducer((state, { payload })=>{
                const userListFromState = dotPropImmutable.get(state, 'users', []);
                return dotPropImmutable.set(state, 'users', uniqBy([
                    ...userListFromState,
                    ...payload
                ], 'userId'));
            }),
            addMembers: create.reducer((state, { payload })=>{
                return dotPropImmutable.merge(state, 'members', payload);
            }),
            updateMember: create.reducer((state, { payload })=>{
                const { user, permissionSet } = payload;
                const members = dotPropImmutable.get(state, 'members', []);
                const updatedMembers = members.map((member)=>{
                    return {
                        ...member,
                        user: member.user.userId === user.userId ? {
                            ...member.user,
                            ...user
                        } : member.user,
                        permissionSet: permissionSet && member.user.userId === user.userId ? {
                            ...member.permissionSet,
                            ...permissionSet
                        } : member.permissionSet
                    };
                });
                return dotPropImmutable.set(state, 'members', updatedMembers);
            }),
            setMembersLoading: create.reducer((state, action)=>{
                state.loading = action.payload;
                state.error = false;
            }),
            setMembersError: create.reducer((state, action)=>{
                state.error = action.payload;
                state.loading = false;
            }),
            setAllMembersSucess: create.reducer((state, action)=>{
                state.loadedAllMembers = action.payload;
                state.error = false;
                state.loading = false;
            })
        })
});
export const selectMembers = (state)=>state.members;
export const selectUsersList = (state)=>{
    var _state_members_users;
    return (_state_members_users = state.members.users) !== null && _state_members_users !== void 0 ? _state_members_users : [];
};
export const selectUser = (id)=>({ members })=>{
        var _members_users;
        return (_members_users = members.users) === null || _members_users === void 0 ? void 0 : _members_users.find((user)=>user.userId === id);
    };
export const { setMembers, addUser, addUsers, addMembers, setMembersLoading, setMembersError, updateMember } = MembersSlice.actions;
export const membersReducer = MembersSlice.reducer;
